function initproductMediaSlider() {
  const productMediaSlider = document.querySelector(".product-media-slider");
  const productMediaThumbnails = document.querySelector(
    ".product-media-thumbnails"
  );

  if (!productMediaSlider || !productMediaThumbnails) return;

  const { sectionId } = productMediaSlider.dataset;

  const slidesCount = productMediaSlider.querySelectorAll(".swiper-slide").length;
  const loopEnabled = slidesCount >= 3;

  const thumbnailSlider = new Swiper(productMediaThumbnails, {
    loop: loopEnabled,
    slidesPerView: 3,
    spaceBetween: 4,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: `.swiper-button-next--${sectionId}`,
      prevEl: `.swiper-button-prev--${sectionId}`,
    },
  });

  const mainSlider = new Swiper(productMediaSlider, {
    loop: loopEnabled,
    slidesPerView: 1,
    navigation: {
      nextEl: `.swiper-button-next--${sectionId}`,
      prevEl: `.swiper-button-prev--${sectionId}`,
    },
    breakpoints: {
      320: {
        slidesPerView: "auto",
      },
      750: {
        slidesPerView: "auto",
      },
    },
    on: {
      afterInit: (swiper) => {
        swiper.thumbs.swiper.params.slideToClickedSlide = true;
        swiper.thumbs.swiper.update();
      },
      realIndexChange: (swiper) => {
        swiper.thumbs.swiper.slideToLoop(swiper.realIndex);
      },
    },
    thumbs: {
      swiper: thumbnailSlider,
    },
  });
}

initproductMediaSlider();

function initproductMediaSliderSS() {
  const productMediaSliderSS = document.querySelector(
    ".ss__recommendation__Carousel .swiper-container"
  );

  if (!productMediaSliderSS) return;

  new Swiper(productMediaSliderSS, {
    slidesPerView: 4,
    loop: true,
    navigation: {
      nextEl: ".ss__carousel__prev-wrapper",
      prevEl: ".ss__carousel__next-wrapper",
    },
    breakpoints: {
      320: {
        slidesPerView: "auto",
        spaceBetween: 4,
      },
      750: {
        slidesPerView: "auto",
        spaceBetween: 4,
      },
    },
  });
}

initproductMediaSliderSS();
